import { Component } from "@angular/core";


export interface PhotoZoomData {
  resource_url: string,
  caption: string  
}

@Component({
  selector: "app-photo-zoom",
  templateUrl: "./photo-zoom.component.html"
})
export class PhotoZoomComponent {

}